export default "__VITE_ASSET__CVPEHzGz__"